import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder } from '../http';

var buildEndpoint = function buildEndpoint(scope, kappSlug) {
  return scope === 'kapp' ? "".concat(bundle.apiLocation(), "/kapps/").concat(kappSlug, "/webhookJobs") : "".concat(bundle.apiLocation(), "/webhookJobs");
};

export var fetchWebhookJobs = function fetchWebhookJobs() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scope = options.scope,
      kappSlug = options.kappSlug,
      status = options.status,
      webhook = options.webhook;
  return axios.get(buildEndpoint(scope, kappSlug), {
    params: _objectSpread(_objectSpread({}, paramBuilder(options)), {}, {
      status: status,
      limit: options.limit,
      pageToken: options.pageToken,
      webhook: webhook
    }),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      webhookJobs: response.data.webhookJobs,
      nextPageToken: response.data.nextPageToken
    };
  })["catch"](handleErrors);
};
export var updateWebhookJob = function updateWebhookJob() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = options.id,
      kappSlug = options.kappSlug,
      scope = options.scope,
      webhookJob = options.webhookJob;

  if (!id) {
    throw new Error('updateWebhookJob failed! The option "id" is required.');
  }

  if (!webhookJob) {
    throw new Error('updateWebhookJob failed! The option "webhookJob" is required.');
  }

  return axios.put("".concat(buildEndpoint(scope, kappSlug), "/").concat(id), webhookJob, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      webhookJob: response.data.webhookJob
    };
  })["catch"](handleErrors);
};